import Login from '../Components/Auth/Login';
import Dashboard from '../Components/Dashboard/Dashboard';
import TableauComponent from '../Components/TableauView/TableauComponent';
import BlankPage from '../Components/BlankPage/BlankPage';
import Documents from '../Components/DocumentsPage/Documents';
// import NotFound from '../Components/Auth/NotFound';

const routes = [
	{
		path: '/login',
		component: Login,
		isPrivate: false,
	},
	{
		path: '/',
		component: Dashboard,
		isPrivate: true,
	},
	// {
	// 	path: '/*',
	// 	element: NotFound,
	// 	isPrivate: true,
	// },
	{
		path: '/dashboard/:id',
		component: TableauComponent,
		isPrivate: true,
	},
	{
		path: '/documents',
		component: Documents,
		isPrivate: true,
	},
	{
		path: '/profile',
		component: BlankPage,
		isPrivate: true,
	},
];

export default routes;
